export const sgdbs = [
  { key: 'FIREBIRD', value: 'FIREBIRD', title: 'Firebird' },
  { key: 'MYSQL', value: 'MYSQL', title: 'MySQL' },
  { key: 'POSTGRESQL', value: 'POSTGRESQL', title: 'PostgreSQL' },
  { key: 'SQLITE', value: 'SQLITE', title: 'SQLite' },
  { key: 'SQLSERVER', value: 'SQLSERVER', title: 'SQLServer' },
  { key: 'SYBASE', value: 'SYBASE', title: 'Sybase' },
];
